
export const links = [
  {
    to: "/admin/customer-overview",
    str: "Klantoverzicht",
  },
  {
    to: "/admin/websites",
    str: "Winkel",
  },
  {
    to: "/admin/marketing",
    str: "Marketing",
  },
  {
    to: "/admin/discounts",
    str: "Kortingen",
  },
  {
    to: "/admin/accounts",
    str: "Gebruikersaccounts",
  },
  {
    to: "/admin/all-products",
    str: "Alle producten",
  },
  {
    to: "/admin/brands",
    str: "Merken",
  },
  {
    to: "/admin/suppliers",
    str: "Leveranciers",
  },
  {
    to: "/admin/categories",
    str: "Categorieën",
  },
  /* {
    to: "/admin/product-groups",
    str: "Productgroep",
  }, */
  /* {
    to: "/admin/website-products",
    str: "Website Producten",
  }, */
  {
    to: "/admin/wholesale-orders",
    str: "Orderpicken",
  },
  {
    to: "/admin/overview-order",
    str: "Overzicht bestellingen",
  },
  {
    to: "/admin/advice-order",
    str: "Advies bestelling",
  },
  {
    to: "/admin/replenishment",
    str: "Aanvulling",
  },
]

export const getAvailableSitesByRole = role => {
  switch (role) {
    case "EMPLOYEE": {
      return [
        "/admin/websites",
        "/admin/all-products",
        "/admin/product/edit/:id",
        "/admin/product/edit",
        "/admin/websites/edit/:id",
        "/admin/wholesale-orders/:id",
        "/admin/websites/edit",
        "/admin/wholesale-orders",
        "/admin/overview-order"
      ]
    }
    case "MAINTAINER": {
      return [
        "/admin/websites",
        "/admin/all-products",
        "/admin/product/edit/:id",
        "/admin/product/edit",
        "/admin/websites/edit/:id",
        "/admin/websites/edit",
        "/admin/wholesale-orders",
        "/admin/wholesale-orders/:id",
        "/admin/overview-order"
      ]
    }
  }
}
